export const isSubmenuItemSelected = (
  submenuItem,
  currentMenuItem,
  lastClickedSubmenuItemId
) =>
  lastClickedSubmenuItemId &&
  submenuItem.appAction.subpageId === currentMenuItem.appAction.subpageId &&
  lastClickedSubmenuItemId === submenuItem.id;
